import { Collapse } from '@lifebit-ai/lds'
import React from 'react'

interface ResultMetaV1Props {
  isFile: boolean
  contentDescription: string
  exportReason: string
}

export const ResultMetaV1: React.FC<ResultMetaV1Props> = ({ isFile, contentDescription, exportReason }) => {
  return (
    <Collapse data-testid="result-meta">
      {contentDescription && (
        <Collapse.Panel key="file-description" header={isFile ? 'File description' : 'Folder description'}>
          <div>{contentDescription}</div>
        </Collapse.Panel>
      )}
      {exportReason && (
        <Collapse.Panel key="reason-for-export" header="Reason for export">
          <div>{exportReason}</div>
        </Collapse.Panel>
      )}
    </Collapse>
  )
}
